function clickProductSeriesIndex(productSeriesIndex) {
        sessionStorage.setItem('clickProductSeriesIndex', productSeriesIndex);
        window.location.href = "https://napcatlife.com/pages/all-product";
    }

    var swiper1 = new Swiper("#screen-mobile", {
        slidesPerView: 'auto',
        spaceBetween: 8,
        touchRatio:1.5,
    });